import { SelectOptionType, SizeType } from '@config/type'
import cn from 'classnames'
import { LegacyRef, Ref, forwardRef } from 'react'
import ReactSelect, {
  GroupBase,
  MenuProps,
  MultiValueProps,
  Props
} from 'react-select'

import { SelectListMarker } from '../select-list-marker'
import { SelectTagItem } from '../select-tag-item'

import styles from './select-multi.module.css'
import Select from 'react-select/base'

export const SelectMulti = forwardRef(
  <
    Option extends SelectOptionType<string>,
    // IsMulti extends boolean = true,
    Group extends GroupBase<Option> = GroupBase<Option>
  >(
    props: Props<Option, true, Group> & {
      controlCls?: string
      searchable?: boolean
      sizeType?: SizeType
      fontType?: SizeType
      styleType?: 'primary' | 'secondary' | 'inverse' | 'transparent' | 'danger'
      borderType?: 'primary' | 'secondary' | 'none' | 'danger' | 'inverse'
      fullHeight?: boolean
      infoTop?: string
      isDisabled?: boolean
      error?: string
      withErrorText?: boolean
    },
    outerRef: Ref<Option>
  ) => {
    const {
      fullHeight,
      controlCls,
      styleType = 'transparent',
      sizeType = 'md',
      fontType = 'sm',
      borderType = 'none',
      error,
      infoTop,
      withErrorText,
      searchable = false,
      isDisabled = false
    } = props
    const { className, components, ...rest } = props
    const containerCls = cn(styles.container, className, {
      [styles.searchable]: searchable === true,
      [styles.xs]: sizeType === 'xs',
      [styles.sm]: sizeType === 'sm',
      [styles.md]: sizeType === 'md',
      [styles.lg]: sizeType === 'lg',
      [styles.xl]: sizeType === 'xl',
      [styles.fontXs]: fontType === 'xs',
      [styles.fontSm]: fontType === 'sm',
      [styles.fontMd]: fontType === 'md',
      [styles.fontLg]: fontType === 'lg',
      [styles.fontXl]: fontType === 'xl',
      [styles.primary]: styleType === 'primary',
      [styles.secondary]: styleType === 'secondary',
      [styles.transparent]: styleType === 'transparent',
      [styles.inverse]: styleType === 'inverse',
      [styles.inactive]: isDisabled === true,
      [styles.borderNone]: borderType === 'none',
      [styles.borderPrimary]: borderType === 'primary',
      [styles.borderSecondary]:
        borderType === 'secondary' && styleType !== 'primary',
      [styles.borderInverse]:
        borderType === 'inverse' && styleType !== 'primary',
      [styles.borderDanger]:
        borderType === 'danger' || Boolean(error) || styleType === 'danger',
      [styles.danger]: Boolean(error) || styleType === 'danger'
    })
    const selectCls = cn(styles.select, controlCls, {
      [styles.fullHeight]: fullHeight === true
    })
    return (
      <div className={containerCls}>
        {infoTop && <span className={styles.title}>{infoTop}</span>}
        <ReactSelect<Option, true, Group>
          ref={outerRef as LegacyRef<Select<Option, true, Group>> | undefined}
          classNamePrefix={'select'}
          className={selectCls}
          menuPortalTarget={document.getElementById('react-select-portal')}
          menuShouldBlockScroll={true}
          isDisabled={isDisabled}
          isMulti={true}
          isClearable={true}
          closeMenuOnSelect={false}
          classNames={{
            menu: () => styles.menu,
            menuPortal: () => styles.menuPortal,
            control: () => styles.control,
            clearIndicator: () => styles.clearIndicator
          }}
          components={{
            Menu: (props: MenuProps<Option, true, Group>) => (
              // @ts-ignore
              <SelectListMarker
                {...props}
                sizeType={sizeType}
                fontType={fontType}
                styleType={styleType}
                borderType={borderType}
              />
            ),
            MultiValueRemove: () => null,
            DropdownIndicator: () => null,
            IndicatorSeparator: () => null,
            MultiValue: (props: MultiValueProps<Option, true, Group>) => (
              // @ts-ignore
              <SelectTagItem {...props} />
            ),
            ...components
          }}
          isSearchable={searchable}
          {...rest}
        />
        {error && withErrorText && (
          <span className={styles.error}>{error}</span>
        )}
      </div>
    )
  }
)
